import React from 'react'
import { Link } from 'react-router-dom'
import './FeesPage.css' // the Feepage stylesheet (same import as Budget.jsx)
import './Aboutsalespartner.css' // affiliate-only additions
import { FaMoneyBillAlt, FaWhatsapp, FaFacebookF, FaRegCopy, FaCheck } from 'react-icons/fa'
import { IoMdBusiness } from 'react-icons/io'
import { HiCursorClick } from 'react-icons/hi'
import Header from './layouts/Header'
import Header5 from './components/Header5'

const STEPS = [
  {
    icon: <HiCursorClick size={28} />,
    title: 'Sign up',
    text: 'Register for the affiliate program and receive your unique affiliate ID and referral tools.',
  },
  {
    icon: <IoMdBusiness size={28} />,
    title: 'Recruit',
    text: 'Refer event organisers, event planners and event managers to Karamale. There is no limit to how many clients you can recruit.',
  },
  {
    icon: <FaMoneyBillAlt size={28} />,
    title: 'Earn',
    text: 'Earn up to 30% commission from the amount your recruits spend on Karamale to sell tickets.',
  },
]

const ReferralViz = () => (
  <div className="fp-viz fp-viz--id" aria-hidden="true">
    <div className="fp-viz__card">
      <span className="fp-viz__tag">Your affiliate ID</span>

      <div className="fp-viz__link">
        <code>
          karamale.com/?affiliateid=<b>your-id</b>
        </code>
        <span className="fp-viz__copy">
          <FaRegCopy size={13} />
        </span>
      </div>

      <div className="fp-viz__share">
        <span className="fp-viz__chip fp-viz__chip--wa">
          <FaWhatsapp size={14} /> WhatsApp
        </span>
        <span className="fp-viz__chip fp-viz__chip--fb">
          <FaFacebookF size={12} /> Share
        </span>
      </div>
    </div>

    <div className="fp-viz__float fp-viz__float--tr">
      <FaCheck size={11} /> Link copied
    </div>
  </div>
)

const RecruitsViz = () => (
  <div className="fp-viz fp-viz--recruits" aria-hidden="true">
    <div className="fp-viz__card">
      <div className="fp-viz__row fp-viz__row--head">
        <span className="fp-viz__tag">Your recruits</span>
        <span className="fp-viz__count">3</span>
      </div>

      <div className="fp-viz__row">
        <i className="fp-viz__avatar fp-viz__avatar--a"></i>
        <span className="fp-viz__bar fp-viz__bar--w70"></span>
        <span className="fp-viz__status fp-viz__status--ok">
          <FaCheck size={9} /> Event created
        </span>
      </div>

      <div className="fp-viz__row">
        <i className="fp-viz__avatar fp-viz__avatar--b"></i>
        <span className="fp-viz__bar fp-viz__bar--w55"></span>
        <span className="fp-viz__status fp-viz__status--ok">
          <FaCheck size={9} /> Event created
        </span>
      </div>

      <div className="fp-viz__row">
        <i className="fp-viz__avatar fp-viz__avatar--c"></i>
        <span className="fp-viz__bar fp-viz__bar--w80"></span>
        <span className="fp-viz__status fp-viz__status--wait">Waiting</span>
      </div>
    </div>

    <div className="fp-viz__float fp-viz__float--bl">+ New recruit</div>
  </div>
)

const WalletViz = () => (
  <div className="fp-viz fp-viz--wallet" aria-hidden="true">
    <div className="fp-viz__card">
      <div className="fp-viz__row fp-viz__row--head">
        <span className="fp-viz__tag">Karamale owes you</span>
        <span className="fp-viz__example">Example</span>
      </div>

      <div className="fp-viz__amount">
        R4 250<small>,00</small>
      </div>

      <div className="fp-viz__bars">
        {[28, 40, 34, 56, 72, 100].map((h, i) => (
          <span key={i} style={{ height: `${h}%`, animationDelay: `${i * 0.08}s` }}></span>
        ))}
      </div>
    </div>

    <div className="fp-viz__float fp-viz__float--tr">↗ Commission growing</div>
  </div>
)

const DASHBOARD = [
  {
    label: 'Referral tool',
    title: 'Affiliate ID',
    viz: <ReferralViz />,
    text: 'Share your unique affiliate ID or referral link with event organisers and encourage them to sell tickets through Karamale.',
  },
  {
    label: 'Your network',
    title: 'Recruits',
    viz: <RecruitsViz />,
    text: 'Your recruits are the Karamale clients you referred using your affiliate ID. Keep track of the clients connected to you.',
  },
  {
    label: 'Your earnings',
    title: 'Your wallet',
    viz: <WalletViz />,
    text: 'Your wallet shows how much Karamale owes you. Your commission can increase as your recruits generate activity.',
  },
]

const FAQS = [
  {
    q: 'How many clients can I recruit?',
    a: 'There is no limit to how many clients you can recruit for Karamale. The more clients you bring onto the platform, the more opportunities you have to earn.',
  },
  {
    q: 'Who can I recruit?',
    a: 'You can refer event planners, event organisers, event managers or anyone who organises events and wants to sell tickets through Karamale.',
  },
  {
    q: 'How do I track my referrals?',
    a: 'After signing up, you receive access to your dashboard and a unique referral link. Clients who register through your link can appear in your recruit list once they create an event.',
  },
  {
    q: 'How do I know when a recruit creates an event?',
    a: "Karamale can notify you by email when a client you've referred creates an event.",
  },
  {
    q: 'How do I get paid?',
    a: "During registration, you'll provide your banking details. Karamale uses those details to process payments due to you, so it is important to make sure they are accurate.",
  },
  {
    q: 'When do recruits appear in my list?',
    a: 'A referred client may not appear in your recruit list immediately after signing up. The client needs to create an event before the recruit becomes visible in the relevant dashboard activity.',
  },
]

class Aboutsalespartner extends React.Component {
  constructor(props) {
    super(props)

    this.state = { openFaq: 0 }
  }

  componentDidMount() {
    document.title = 'Karamale - About Affiliate Program'
  }

  toggleFaq(index) {
    this.setState((prev) => ({ openFaq: prev.openFaq === index ? null : index }))
  }

  render() {
    const { openFaq } = this.state
    const isPartner = localStorage.getItem('partnerid') !== null

    return (
      <div className="fp-page">
        {isPartner ? <Header5 /> : <Header />}

        <main>
          {/* ---------- Hero ---------- */}
          <section className="fp-hero">
            <div className="fp-aurora" aria-hidden="true">
              <span className="fp-aurora__a"></span>
              <span className="fp-aurora__b"></span>
            </div>

            <div className="fp-wrap fp-hero__inner">
              <div>
                <span className="fp-pill">
                  <i></i>Karamale affiliate program
                </span>

                <h1>
                  Turn your <em>network into income.</em>
                </h1>

                <p className="fp-hero__sub">
                  Refer event organisers to Karamale, help them sell tickets and earn commission
                  from their activity on the platform.
                </p>

                <div className="fp-actions">
                  <Link to="/affiliate-registration" className="fp-btn fp-btn--brand">
                    Become an affiliate →
                  </Link>
                  <a href="#how-it-works" className="fp-btn fp-btn--ghost">
                    How it works
                  </a>
                </div>
              </div>

              <div className="fp-hero__visual">
                <div className="fp-bigcard">
                  <small>Your potential</small>
                  <strong>30%</strong>
                  <div className="fp-bigcard__line">
                    Earn up to 30% commission from the amount your recruits spend on Karamale to
                    sell tickets.
                  </div>
                </div>

                <div className="fp-mini fp-mini--one">
                  <small>Recruit limit</small>
                  <strong>None</strong>
                  <span>Recruit as many as you like.</span>
                </div>

                <div className="fp-mini fp-mini--two">
                  <small>How it works</small>
                  <strong>3 steps</strong>
                  <span>Sign up, recruit, earn.</span>
                </div>
              </div>
            </div>
          </section>

          {/* ---------- The program ---------- */}
          <section className="fp-section">
            <div className="fp-wrap fp-two">
              <div>
                <span className="fp-pill">
                  <i></i>The program
                </span>

                <h2 className="fp-h2 fp-h2--mt">
                  Your audience. <span>Your opportunity.</span>
                </h2>

                <p className="fp-lead">
                  Karamale's affiliate program allows influencers, bloggers, event professionals and
                  members of the public to earn by referring event organisers to Karamale.
                </p>

                <p className="fp-lead fp-lead--tight">
                  Every affiliate receives a unique affiliate ID and referral tools. Use them to
                  direct event organisers to Karamale. When those organisers use the platform to
                  sell tickets, you can earn commission.
                </p>
              </div>

              <div className="fp-panel">
                <div className="fp-panel__head">
                  <span>What you get</span>
                  <b>
                    <i></i>Every affiliate
                  </b>
                </div>

                <ul className="fp-checks">
                  <li>A unique affiliate ID</li>
                  <li>Referral tools to send organisers to Karamale</li>
                  <li>Commission when your recruits sell tickets</li>
                  <li>
                    A dashboard with your recruits, their events, admission sales and payments due
                    to you
                  </li>
                </ul>
              </div>
            </div>
          </section>

          {/* ---------- Steps ---------- */}
          <section className="fp-section" id="how-it-works">
            <div className="fp-wrap">
              <div className="fp-head">
                <h2 className="fp-h2">
                  Three steps. <span>One opportunity.</span>
                </h2>

                <p>
                  The process is simple. Sign up, bring event organisers onto Karamale and track
                  your earnings from your dashboard.
                </p>
              </div>

              <div className="fp-cols">
                {STEPS.map((step, index) => (
                  <div className={`fp-card ${index === 0 ? 'fp-card--hot' : ''}`} key={step.title}>
                    <div className="fp-aff-icon">
                      {step.icon}
                      <b>{index + 1}</b>
                    </div>
                    <h3>{step.title}</h3>
                    <p>{step.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* ---------- Dashboard ---------- */}
          <section className="fp-section">
            <div className="fp-wrap">
              <div className="fp-head">
                <h2 className="fp-h2">
                  Everything you need <span>in your dashboard.</span>
                </h2>

                <p>
                  Your affiliate dashboard gives you the tools to understand your referrals, monitor
                  activity and keep track of your earnings.
                </p>
              </div>

              <div className="fp-cols">
                {DASHBOARD.map((item) => (
                  <article className="fp-card fp-card--shot" key={item.title}>
                    {item.viz}

                    <div className="fp-card--shot__copy">
                      <span className="fp-aff-label">{item.label}</span>
                      <h3>{item.title}</h3>
                      <p>{item.text}</p>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </section>

          {/* ---------- Commission ---------- */}
          <section className="fp-section">
            <div className="fp-wrap">
              <div className="fp-flow">
                <div>
                  <h2 className="fp-h2">
                    Your network can <span>keep growing.</span>
                  </h2>

                  <p className="fp-lead">
                    There is no limit to the number of clients you can recruit. Every organiser you
                    bring to Karamale becomes part of your referral network.
                  </p>
                </div>

                <div className="fp-aff-center">
                  <div className="fp-zero">
                    <small>Up to</small>
                    <strong>30%</strong>
                    <small>commission</small>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* ---------- FAQ ---------- */}
          <section className="fp-section">
            <div className="fp-wrap fp-faq">
              <div>
                <h2 className="fp-h2">
                  Questions? <span>We've got answers.</span>
                </h2>
              </div>

              <div className="fp-faq__list">
                {FAQS.map((faq, index) => {
                  const isOpen = openFaq === index

                  return (
                    <div className={`fp-faq__item ${isOpen ? 'is-open' : ''}`} key={faq.q}>
                      <button
                        type="button"
                        aria-expanded={isOpen}
                        onClick={() => this.toggleFaq(index)}
                      >
                        {faq.q}
                        <b>{isOpen ? '−' : '+'}</b>
                      </button>

                      {isOpen && <div className="fp-faq__answer">{faq.a}</div>}
                    </div>
                  )
                })}
              </div>
            </div>
          </section>

          {/* ---------- Privacy + CTA ---------- */}
          <section className="fp-section fp-section--last">
            <div className="fp-wrap">
              <div className="fp-note fp-note--flush">
                <span className="fp-tick"></span>
                <div>
                  <strong>Your information stays yours.</strong>
                  <p>
                    Your banking details are used to process payments and are not shared with other
                    companies for unrelated purposes.
                  </p>
                </div>
              </div>

              <div className="fp-cta fp-cta--gap">
                <h2>
                  Build your network. <em>Earn from it.</em>
                </h2>
                <p>
                  Join the Karamale affiliate program and start referring event organisers today.
                </p>

                <div className="fp-actions fp-actions--center">
                  <Link to="/affiliate-registration" className="fp-btn fp-btn--light">
                    Sign up as an affiliate →
                  </Link>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    )
  }
}

export default Aboutsalespartner
